// Simple audio wrapper - Howler.js integration
// For now, this is a placeholder that can be expanded with real audio

export class AudioSystem {
  private muted = false;

  async load(_id: string, _url: string): Promise<void> {
    // Placeholder for Howler.js integration
  }

  play(_id: string, _volume = 1): void {
    if (this.muted) return;
    // Placeholder
  }

  stop(_id: string): void {
    // Placeholder
  }

  setMusicVolume(_volume: number): void {
    // Placeholder
  }

  setSfxVolume(_volume: number): void {
    // Placeholder
  }

  toggleMute(): void {
    this.muted = !this.muted;
  }

  get isMuted(): boolean {
    return this.muted;
  }
}
